import { useEffect, useState } from 'react';
import {
    FaAngleDown,
    FaPencilAlt,
    FaRegTimesCircle,
    FaRegTrashAlt,
} from 'react-icons/fa';
import PropTypes from 'prop-types';
import './CartItem.css';
import { useDispatch, useSelector } from 'react-redux';
import {
    removeCartItem,
    removeCartItemExtra,
    resetIsCompleteCart,
    setCurrentStep,
    setItemIsCompleted,
    setItemIsNotCompleted,
} from 'features/cart/cartSlice';
import { toast } from 'react-toastify';
import axios from 'axios';
import { apiConfig } from 'config';

const CartItem = ({ item, count, selected, hasCartExtras }) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const currency = useSelector((state) => state.user?.currency);
    const [isOpen, setIsOpen] = useState(() => selected);
    const currentStep = useSelector((state) => state.cart?.currentStep);
    const onClick = () => {
        if (item.isCompleted || selected || currentStep === 2) {
            setIsOpen(!isOpen);
        }
    };
    const cartItems = useSelector((state) => state.cart?.cartItems);
    const hasExtrasForItem = useSelector((state) => state.cart?.hasExtras);

    useEffect(() => {
        setIsOpen(selected);
    }, [selected, item.isCompleted]);

    const hasExtra = item?.extras && item?.extras.length > 0;

    const removeItem = async (rateID, roomTypeID) => {
        dispatch(resetIsCompleteCart());
        dispatch(setCurrentStep({ currentStep: 1 }));
        const cartItem = cartItems.find(
            (item) => item.rateID === rateID && item.roomTypeID === roomTypeID
        );
        if ((await removeFromCartBack(cartItem)) === 'ok') {
            dispatch(removeCartItem(rateID));
        }
    };

    const removeFromCartBack = async (cartItem) => {
        try {
            const response = await axios.post(apiConfig?.removeFromCartBack, {
                ...cartItem,
            });

            if (response?.data.split(',')[0].toLowerCase() === 'ok') {
                return 'ok';
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const onClickTrash = async (extra) => {
        if ((await removeFromCartExtraBack(extra)) === 'ok') {
            dispatch(
                removeCartItemExtra({
                    rateID: extra.rateID,
                    roomTypeID: extra.roomTypeID,
                    addOnID: extra.addOnID,
                })
            );
        }
    };

    const removeFromCartExtraBack = async (extra) => {
        try {
            const extraItem = { ...extra };
            extraItem.cartID = item?.cartID;
            extraItem.propCode = item?.propCode;
            const response = await axios.post(
                apiConfig?.removeFromCartExtraBack,
                { ...extraItem }
            );

            if (response?.data.toLowerCase() === 'ok') {
                return 'ok';
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    // const completeItemCartBack = async (item) => {
    //     try {
    //         const cartItem = { ...item };
    //         cartItem.isCompleted = true;

    //         const response = await axios.post(
    //             'https://devhotelmanager.abouthotelier.com/API/Price/completeItemCartBack',
    //             { ...cartItem }
    //         );

    //         if (response?.data.toLowerCase() === 'ok') {
    //             return 'ok';
    //         } else {
    //             toast.error(Lang?.somethingWentWrong, {
    //                 autoClose: true,
    //                 theme: 'colored',
    //                 PlacementType: 'top-left',
    //             });
    //             return 'error';
    //         }
    //     } catch (error) {
    //         toast.error(Lang?.networkError, {
    //             autoClose: true,
    //             theme: 'colored',
    //         });
    //         return 'error';
    //     }
    // };

    const onClickContinue = async () => {
        // if ((await completeItemCartBack(item)) === 'ok') {
        dispatch(
            setItemIsCompleted({
                rateID: item.rateID,
                roomTypeID: item.roomTypeID,
            })
        );
        // }
    };

    const setThisNotCompleted = () => {
        dispatch(
            setItemIsNotCompleted({
                rateID: item.rateID,
                roomTypeID: item.roomTypeID,
            })
        );
    };

    const totalPrice = item?.extras?.reduce((total, extra) => {
        const extraPrice = Number(extra.price) || 0;
        const extraQuantity = Number(extra.quantity) || 0;
        return total + extraPrice * extraQuantity;
    }, 0);
    return (
        <div className={`sidebar_room ${isOpen && 'open'}`}>
            <div className="sidebar_room_trigger">
                <p onClick={() => onClick()}>
                    <span className="text">
                        {Lang?.Room.toUpperCase().replace('Ά', 'Α')} {count}
                    </span>{' '}
                    <FaAngleDown className="sign" />
                </p>

                <div className="sidebar-room-trash">
                    {currentStep === 1 && (
                        <div
                            className=""
                            title="Remove from cart"
                            onClick={() =>
                                removeItem(item?.rateID, item?.roomTypeID)
                            }
                            style={{
                                margin: '0',
                                cursor: 'pointer',
                                height: '32px',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <span style={{ marginRight: '5px' }}>
                                {Lang?.remove}
                            </span>

                            <FaRegTimesCircle size={20} />
                        </div>
                    )}
                </div>
            </div>
            <div className="sidebar_room_hidden" id="room_hidden_2825">
                <div className="sidebar_info_detail_rows">
                    <div className="sidebar_info_detail_row justify-between flex">
                        <div className="sidebar_info_detail_row_title flex column justify-center">
                            <p style={{ fontWeight: '600' }}>Check in</p>
                        </div>
                        <div className="sidebar_info_detail_row_detail">
                            <p style={{ color: 'grey' }}>
                                {item.checkin}
                                <br />
                                After 15:00
                            </p>
                        </div>
                    </div>
                    <hr
                        style={{
                            display: 'inline-block',
                            width: '100%',
                            marginTop: '0px',
                            border: 'solid 1px #d1d6db',
                            marginBottom: '0',
                        }}
                    />
                    <div className="sidebar_info_detail_row justify-between flex">
                        <div className="sidebar_info_detail_row_title flex column justify-center">
                            <p style={{ fontWeight: '600' }}>Check out</p>
                        </div>
                        <div className="sidebar_info_detail_row_detail">
                            <p style={{ color: 'grey' }}>
                                {item.checkout}
                                <br />
                                Before 11:00
                            </p>
                        </div>
                    </div>
                    <hr
                        style={{
                            display: 'inline-block',
                            width: '100%',
                            border: 'solid 1px #d1d6db',
                            marginBottom: '3px',
                            marginTop: '10px',
                        }}
                    />
                </div>
                <div
                    className="sidebar_room_hidden_info_row"
                    style={{ fontWeight: 700 }}
                >
                    <div className="sidebar_room_hidden_info_title flex column">
                        <span className="leftnote">{item.roomName}</span>
                    </div>
                    <div className="sidebar_room_hidden_info_title flex column">
                        <span className="leftnote">
                            {item.price} € / {Lang?.Room}
                        </span>
                    </div>
                </div>
                <div className="sidebar_room_hidden_info_row">
                    <div className="sidebar_room_hidden_info_title flex column">
                        <span className="leftnote">{item.rateName}</span>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <div className="sidebar_room_hidden_info_row">
                            <div className="sidebar_room_hidden_info_title flex column">
                                <span className="leftnote">
                                    x {item.quantity} Rooms
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sidebar_room_hidden_info_row">
                    <div className="sidebar_room_hidden_info_detail">
                        <span className="leftnote">
                            {item.adults} {Lang?.Adults}
                            {item?.children > 0 &&
                                `, ${item?.children} Childern`}
                        </span>
                    </div>
                </div>
                {hasCartExtras && (
                    <>
                        <div
                            className="sidebar_room_hidden_info_edit"
                            style={{
                                borderTop: 'solid 2px #d1d6db',
                                marginTop: '5px',
                                paddingTop: '5px',
                            }}
                        >
                            <div
                                className="sidebar_room_hidden_info_detail"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    textAlign: 'left',
                                }}
                            >
                                <p>{Lang.extras}</p>
                            </div>
                            {currentStep === 1 && (
                                <div className="sidebar_extra_trash">
                                    <div
                                        className="sidebar_extra_trash-icon "
                                        onClick={() =>
                                            setThisNotCompleted(item)
                                        }
                                    >
                                        <FaPencilAlt />
                                    </div>
                                </div>
                            )}
                        </div>
                        {item?.extras?.map((extra, index) => {
                            return (
                                <div
                                    key={index}
                                    className="sidebar_room_hidden_info_row"
                                    style={{ flexDirection: 'column' }}
                                >
                                    <div className="sidebar_extra_row">
                                        <p>{extra.title}</p>
                                        {currentStep === 1 && (
                                            <div className="sidebar_extra_trash">
                                                <div
                                                    className="sidebar_extra_trash-icon "
                                                    onClick={() =>
                                                        onClickTrash(extra)
                                                    }
                                                >
                                                    <FaRegTrashAlt />
                                                </div>
                                            </div>
                                        )}
                                        <div>
                                            <p className="sidebar_extra_price">
                                                {new Intl.NumberFormat(
                                                    'en-US',
                                                    {
                                                        style: 'currency',
                                                        currency: currency,
                                                    }
                                                ).format(
                                                    Number(extra.price) *
                                                        Number(extra.quantity)
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}

                <div
                    className="sidebar_room_hidden_info_row"
                    style={{
                        borderTop: 'solid 2px #d1d6db',
                        marginTop: '5px',
                        paddingTop: '5px',
                    }}
                >
                    <div
                        className="sidebar_room_hidden_info_detail"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            textAlign: 'left',
                        }}
                    >
                        <p>{Lang?.total}</p>
                        <p>
                            {new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currency,
                            }).format(
                                Number(item.price) * Number(item.quantity) +
                                    totalPrice
                            )}
                        </p>
                    </div>
                </div>
                {item?.prePayPrice > 0 && (
                    <div
                        className="sidebar_room_hidden_info_row"
                        style={{
                            borderTop: 'solid 2px #d1d6db',
                            marginTop: '5px',
                            paddingTop: '5px',
                        }}
                    >
                        <div
                            className="sidebar_room_hidden_info_detail"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                                textAlign: 'left',
                            }}
                        >
                            <p>{Lang?.paymentAmount}</p>
                            <p>
                                {new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: currency,
                                }).format(Number(item?.prePayPrice))}
                            </p>
                        </div>
                    </div>
                )}

                {!item.isCompleted && (
                    <div
                        className="ab-cart-continue"
                        onClick={() => onClickContinue(item)}
                    >
                        {!hasExtrasForItem
                            ? Lang?.continueWithoutExtras
                            : hasExtra
                            ? Lang?.continueTxt
                            : Lang?.continueWithoutExtras}
                    </div>
                )}
            </div>
        </div>
    );
};

CartItem.propTypes = {
    item: PropTypes.object,
    count: PropTypes.number,
    selected: PropTypes.bool,
    hasCartExtras: PropTypes.bool,
};

export default CartItem;
